export const DRAWER_WIDTH: number = 240;
export const DRAWER_MOBILE_WIDTH: number = 350;
export const SIDE_PANEL_WIDTH: number = 370;
export const COVER_WIDTH: number = 360;
